module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium_1.51de00ba.woff";